import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class HotImgs extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    render() {
        const { content } = this.props;

        // const hotImgsArr = content.slice(0,5) ;

        // const hotTxtArr = content.slice(5,content.length-1);

        return (
            <div>
                <div className={styles.sg_lst}>
                    <div className={styles.arl_rs_tit}>
                        <h3>热图</h3>
                    </div>
                    <ul className={styles.sg_lst_pic}>
                        {content.slice(0, 4).map((item, index) => (
                            <li key={index}>
                                <a target="_blank" rel={rel} href={item.url}>
                                    <img src={item.img} />
                                </a>
                                <a className={styles.li_title} target="_blank" rel={rel} href={item.url}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.sg_lst}>
                    <ul className={styles.sg_lst_txt}>
                        {content.slice(4, content.length).map((item, index) => (
                            <li key={index}>
                                <a target="_blank" rel={rel} href={item.url} title={item.title}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(HotImgs);
